import React, { useState, useEffect } from 'react'; // Added useEffect
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import WorkSection from './WorkSection';
import ContactStack from '../ContactPage/ContactPage';
import { AnimatePresence } from 'framer-motion';

const Works = () => {
  const [showContact, setShowContact] = useState(false);

  // FORCE SCROLL TO TOP ON LOAD
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Navbar />
      <div className="pt-20"> {/* Prevents content from hiding under fixed navbar */}
        <WorkSection/>
      </div>
      
      <Footer onContactClick={() => setShowContact(true)} />

      <AnimatePresence>
        {showContact && (
          <ContactStack onClose={() => setShowContact(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default Works;